export enum ReweighLogHeaderFilterTypes {
  PRO_SEARCH = 'proSearch',
  FILTER_SEARCH = 'filterSearch',
}
